module.exports = __webpack_public_path__ + "img/121.1.a1a0f056.jpg";